// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulkUploadSampleFile::part(message-icon) {
  margin-top: 3px;
}

.textAreaErr::part(textarea),
.bulk-upload-body-container .wpp-single-select::part(single-select-input),
.bulk-file-upload-zone::part(file-upload-container) {
  border: 1px solid var(--wpp-danger-color-500);
}`, "",{"version":3,"sources":["webpack://./src/containers/BulkCreateStrategyWizard/steps/AttachFlights/components/BulkUploader/style.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;;;EAGE,6CAAA;AACF","sourcesContent":[".bulkUploadSampleFile::part(message-icon) {\n  margin-top: 3px;\n}\n\n.textAreaErr::part(textarea),\n.bulk-upload-body-container .wpp-single-select::part(single-select-input),\n.bulk-file-upload-zone::part(file-upload-container) {\n  border: 1px solid var(--wpp-danger-color-500)\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
